module.exports = __webpack_public_path__ + "static/media/link-logo-citi.63246f2e.png";